<template>
  <el-card>
    <iframe
      width="100%"
      height="515"
      src="https://www.youtube.com/embed/wDwUNDrZORo"
      title="YouTube video player"
      frameborder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowfullscreen
    >
    </iframe>
  </el-card>
</template>

<script>
export default {
  name: "trainingMview"
};
</script>

<style></style>
